import { render, staticRenderFns } from "./EnvelopingSignConfigEditor.vue?vue&type=template&id=1373c064&scoped=true&"
import script from "./EnvelopingSignConfigEditor.vue?vue&type=script&lang=js&"
export * from "./EnvelopingSignConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373c064",
  null
  
)

export default component.exports